"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = [
    'recommend_home_visit',
    'recommend_details',
    'energy_advisor_notes',
    'supporting_image_1',
    'supporting_image_2',
    'supporting_image_3',
    'supporting_image_4',
    'supporting_image_5',
    'supporting_image_6',
];
var ClosingsForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _k = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.closings) || {}), formErrors = _k[0], setFormErrors = _k[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.closings) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.closings]);
    return (react_1.default.createElement(__1.Card, { heading: trans('project:slhh::headings.closings'), subHeading: trans('project:slhh::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.closings) === null || _e === void 0 ? void 0 : _e.recommend_home_visit, label: trans('project:slhh::labels.recommend-home-visit') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.closings.recommend_home_visit", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.closings) === null || _g === void 0 ? void 0 : _g.recommend_details, label: trans('project:slhh::labels.recommend-details') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.closings.recommend_details", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { flush: true, errors: (_j = (_h = errors.project) === null || _h === void 0 ? void 0 : _h.closings) === null || _j === void 0 ? void 0 : _j.energy_advisor_notes, label: trans('project:slhh::labels.energy-advisor-notes') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.closings.energy_advisor_notes", maxLength: 5000 }))));
};
exports.default = ClosingsForm;
//# sourceMappingURL=ClosingsForm.js.map